import axios from '../axios.js';

var api = {
  //导航
  getNavInfo(params){
    return axios.post('index/courses/detail',params)
  },
  //课程优势
  classAdvantage(params){
    return axios.post('index/courses/advantage',params)
  },
  //出分效果
  studyEffect(params){
    return axios.post('index/courses/show_achievement',params)
  },
  //常见问题
  commonProblem(params){
    return axios.post('index/courses/common_problem',params)
  },
  //学员案例
  studentCase(params){
    return axios.post('index/cases/student',params)
  },
  //课程安排
  arrangeClass(params){
    return axios.post('index/courses/list',params)
  },
  //课程简介
  courseIntroducte(params){
    return axios.post('index/courses/introduce',params)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/sprintClass.js